// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__16YcB","colMin":"styles_colMin__Llcvs","colCheckbox":"styles_colCheckbox__paZtJ"};